import React from 'react';
import styled from 'styled-components';

export const ModifierBanner = ({
  content,
  isMobile,
}: {
  content: string;
  isMobile: boolean;
}) => (
  <StyledBanner
    dangerouslySetInnerHTML={{ __html: content }}
    isMobile={isMobile}
  />
);

const StyledBanner = styled.div<{
  isMobile: boolean;
}>`
  border-radius: 4px;
  overflow: hidden;
`;
